import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import { api } from 'src/Services/api'
import { APP } from 'src/Configs/App'

import { NameSpace } from '../types'

interface PaymentEvent {
  campaignId: number | string
  url: string
}

interface PaymentPlatformEvent {
  campaignId: number | string
  url: string
  platform: string
}

interface PaymentInfoEvent {
  campaignID: number | string
  url: string
}

export const sendPaymentStartEvent = createAsyncThunk<void, PaymentEvent>(
  `${NameSpace.GoogleAnalytics}/sendPaymentStartEvent`,
  async ({ campaignId, url }, { rejectWithValue }) => {
    try {
      const { data } = await api.post<void>(
        `${APP.TIKTOK_SERVER}/artist/facebook-analytics/checkout-initiated/spotify/${campaignId}`,
        { url },
      )
      return data
    } catch (error) {
      const { response } = error as AxiosError<{ message: string }>
      return rejectWithValue({
        message: response?.data.message,
        status: response?.status,
      })
    }
  },
)

export const sendPaymentStartPlatformEvent = createAsyncThunk<
  void,
  PaymentPlatformEvent
>(
  `${NameSpace.GoogleAnalytics}/sendPaymentStartPlatformEvent`,
  async ({ campaignId, platform, url }, { rejectWithValue }) => {
    try {
      const { data } = await api.post<void>(
        `${APP.TIKTOK_SERVER}/artist/facebook-analytics/checkout-initiated/${platform}/${campaignId}`,
        { url },
      )
      return data
    } catch (error) {
      const { response } = error as AxiosError<{ message: string }>
      return rejectWithValue({
        message: response?.data.message,
        status: response?.status,
      })
    }
  },
)

export const sendPaymentInfoEvent = createAsyncThunk<void, PaymentInfoEvent>(
  `${NameSpace.GoogleAnalytics}/sendPaymentInfoEvent`,
  async ({ campaignID, url }, { rejectWithValue }) => {
    try {
      const { data } = await api.post<void>(
        `${APP.TIKTOK_SERVER}/artist/facebook-analytics/payment-info-added/${campaignID}`,
        { url },
      )
      return data
    } catch (error) {
      const { response } = error as AxiosError<{ message: string }>
      return rejectWithValue({
        message: response?.data.message,
        status: response?.status,
      })
    }
  },
)
